import React, { useState, useEffect } from "react";
import posthog from "posthog-js";
import { useNavigate } from "react-router-dom";
import "./mobile.css";

const MobileProducts = ({
  currentProducts = [],
  handleAddToCart,
  currentPage,
  activeCategory,
}) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate a delay for loading
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  // const handleProductClick = (product) => {
  //   posthog.capture("Product Clicked", {
  //     property: "Product Name",
  //     value: product.item_name,
  //   });
  //   navigate(`/ProductDetails/${product.id}`, { state: { product } });
  // };

  const handleProductClick = (product) => {
    // Track the product click event using posthog
    posthog.capture("Product Click", {
      property: "Product Name",
      value: product.item_name,
    });

    // Navigate to the product details page
    navigate(`/ProductDetails/${product.id}`, {
      state: {
        product,
        fromProducts: true,
        page: currentPage,
        category: activeCategory, 
      },
    });
  };

  if (loading) {
    return (
      <div className="mobile-products-container">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="mobile-product-card skeleton">
            <div className="product-image-container skeleton-box"></div>
            <div className="product-info">
              <div className="skeleton-box skeleton-text"></div>
              <div className="skeleton-box skeleton-text"></div>
              <div className="skeleton-box skeleton-button"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mobile-products-container">
      {currentProducts.map((product) => (
        <div className="mobile-product-card" key={product.id}>
          <div className="product-image-container">
            <img
              src={product.itemPhotos[0]}
              alt={product.item_name}
              onClick={() => handleProductClick(product)}
            />
          </div>
          <div className="product-info">
            <h3 className="product-names">{product.item_name}</h3>
            <div className="product-price-container">
              <span className="product-price">K{product.price.toFixed(2)}</span>
            </div>
            <div className="product-condition">
              <span
                className={`conditon-badge ${product.condition.toLowerCase()}`}
              ></span>
            </div>
            <button
              className={`addCart ${!product.available ? "disable" : ""}`}
              disabled={!product.available}
            >
              <span>
                <svg
                  onClick={() => handleAddToCart(product)}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 18 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0h8m-8 0-1-4m9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-9-4h10l2-7H3m2 7L3 4m0 0-.792-3H1"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileProducts;
